<template>
  <a-result status="500"
            :sub-title="title">
  </a-result>
</template>
<script>
export default {
  props: ['message'],
  computed: {
    title: function () {
      if (this.message) {
        return this.message
      } else {
        return '暂无数据'
      }
    }
  }
}
</script>
